// extracted by mini-css-extract-plugin
export default {"container":"TextTab_container__3QsNe","textarea":"TextTab_textarea__aAgmj","actions":"TextTab_actions__Bt7Ba"};